import { t } from 'i18next';
import useCurrentCountry from 'hooks/useCurrentCountry';
import { genderOptions, genderOptionsUk } from 'model/CommonFields';
import { Field } from './field';
import { AC } from 'settings/form';
const { isUk, isFr } = useCurrentCountry();

export const catalogRequestFormFields: Record<string, Field> = {
  civility: {
    label: t('LABEL_TITLE_GENDER'),
    name: 'civility',
    type: 'radio',
    options: isUk ? genderOptionsUk : genderOptions,
    required: true,
    autoComplete: AC.HonorificPrefix,
  },
  lastName: {
    label: t('LABEL_SURNAME'),
    name: 'lastName',
    required: true,
    autoComplete: AC.LastName,
  },
  firstName: {
    label: t('LABEL_FIRST_NAME'),
    name: 'firstName',
    required: true,
    autoComplete: AC.FirstName,
  },
  email: {
    label: t('LABEL_EMAIL_ADDRESS'),
    name: 'email',
    required: true,
    autoComplete: AC.Email,
  },
  nameWay: {
    name: 'nameWay',
    label: t('LABEL_NAME_WAY'),
    required: true,
    autoComplete: AC.StreetAddress,
  },
  ...(isFr && {
    nameComplement: {
      label: t('LABEL_BUILDING_COMPLEMENT'),
      name: 'nameComplement',
      autoComplete: AC.Off,
    },
  }),
  nameAddress: {
    name: 'nameAddress',
    label: t('LABEL_BUILDING'),
    autoComplete: AC.Off,
  },
  locality: {
    name: 'locality',
    label: t('LABEL_LOCALITY'),
    autoComplete: AC.Off,
  },
  postCode: {
    name: 'postCode',
    label: t('LABEL_POSTCODE'),
    required: true,
    uppercase: isUk,
    autoComplete: AC.PostalCode,
    validation: isFr ? 'number' : undefined,
  },
  city: {
    name: 'city',
    label: t('LABEL_CITY'),
    required: true,
    autoComplete: AC.City,
    validation: 'letter',
  },
  country: {
    name: 'country',
    label: t('LABEL_COUNTRY'),
    required: true,
    disabled: true,
    autoComplete: AC.Country,
  },
  landLine: {
    name: 'landLine',
    label: t('LABEL_LANDLINE'),
    type: 'tel',
    autoComplete: AC.Landline,
    validation: 'number',
  },
  mobileNumber: {
    name: 'mobileNumber',
    label: t('LABEL_PHONE_NUMBER'),
    type: 'tel',
    autoComplete: AC.Off,
    validation: 'number',
  },
};
